import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Smiley.es.js";
const o = e.forwardRef((m, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...m, weights: a }));
o.displayName = "SmileyIcon";
const s = o;
export {
  s as Smiley,
  o as SmileyIcon
};
